import { getBranchId, getHospitalId, getLoginID } from "../../../auth";
import FetchData from "../../client";

export const FetchGenericMedicinesList = async (inputData) => {
  try {
    // inputData.clinicid = getBranchId();
    inputData.hospitalid = getHospitalId();
    const result = await FetchData("midoc_getgenericdrug", inputData);

    if (result.output.data) {
      var data = result.output.data;
      let count = result?.output?.count;
      let pageno = result?.output?.pageno;
      let pagesize = result?.output?.pagesize;
      var finalOutput = {
        data,
        count,
        pageno,
        pagesize,
      };
      // console.log(finalOutput, "final OUtuput");
      return finalOutput;
    }
  } catch (error) {
    console.error("Error fetching data in forms.js:", error);
    throw error;
  }
};

export const FetchFilteredGenericMedicinesList = async (inputData) => {
  try {
    inputData.branchid = getBranchId();
    inputData.hospitalid = getHospitalId();
    const result = await FetchData("midoc_getgenericdrug", inputData);

    if (result.output.data) {
      var data = result.output.data;
      let count = result?.output?.count;
      let pageno = result?.output?.pageno;
      let pagesize = result?.output?.pagesize;
      var finalOutput = {
        data,
        count,
        pageno,
        pagesize,
      };
      // console.log(finalOutput, "final OUtuput");
      return finalOutput;
    }
  } catch (error) {
    console.error("Error fetching data in forms.js:", error);
    throw error;
  }
};

export const AddGenericMedicine = async (inputData) => {
  try {
    inputData.doctorid = getLoginID();
    inputData.branchid = getBranchId();
    inputData.hospitalid = getHospitalId();

    const result = await FetchData("midoc_addgenericdrug ", inputData);
    //console.log(result , " db response of add medicane")
    return result;
  } catch (error) {
    console.error("Error fetching data in forms.js:", error);
    throw error;
  }
};

export const DeleteGenericMedicine = async (inputData) => {
  try {
    const result = await FetchData("midoc_deletegenericdrug", inputData);
    return result;
  } catch (error) {
    console.error("Error fetching data in forms.js:", error);
    throw error;
  }
};

export const EditGenericMedicine = async (inputData) => {
  try {
    inputData.branchid = getBranchId();
    inputData.hospitalid = getHospitalId();
    const result = await FetchData("midoc_updategenericdrug", inputData);

    return result;
  } catch (error) {
    console.error("Error fetching data in forms.js:", error);
    throw error;
  }
};
